import { AGENT_API } from '../AgentAPI';
import { convertUnixToDate } from '@golden/gdk-base';
import { getUnixTime } from 'date-fns';
import { map } from 'rxjs';
export function createReportService(api) {
    return {
        // commission
        getCommission(payload) {
            const data = {
                ...payload,
                settled_start_at: payload.settled_start_at ? getUnixTime(+payload.settled_start_at) : undefined,
                settled_end_at: payload.settled_end_at ? getUnixTime(+payload.settled_end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_COMMISSION, { data });
        },
        getCommissionDetailCommission(payload) {
            const data = {
                ...payload,
                settled_start_at: payload.settled_start_at ? getUnixTime(+payload.settled_start_at) : undefined,
                settled_end_at: payload.settled_end_at ? getUnixTime(+payload.settled_end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_COMMISSION_COMMISSION_DETAIL, { data });
        },
        getCommissionDetailFeedback(payload) {
            const data = {
                ...payload,
                settled_start_at: payload.settled_start_at ? getUnixTime(+payload.settled_start_at) : undefined,
                settled_end_at: payload.settled_end_at ? getUnixTime(+payload.settled_end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_COMMISSION_FEEDBACK_DETAIL, { data });
        },
        getCommissionDetailPlatformFee(payload) {
            const data = {
                ...payload,
                settled_start_at: payload.settled_start_at ? getUnixTime(+payload.settled_start_at) : undefined,
                settled_end_at: payload.settled_end_at ? getUnixTime(+payload.settled_end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_COMMISSION_PLATFORM_FEE_DETAIL, { data });
        },
        getCommissionDetailRiskAdjustment(payload) {
            const data = {
                ...payload,
                settled_start_at: payload.settled_start_at ? getUnixTime(+payload.settled_start_at) : undefined,
                settled_end_at: payload.settled_end_at ? getUnixTime(+payload.settled_end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_COMMISSION_RISK_ADJUSTMENT_DETAIL, { data });
        },
        getCommissionDetailFinanceFee(payload) {
            const data = {
                ...payload,
                settled_start_at: payload.settled_start_at ? getUnixTime(+payload.settled_start_at) : undefined,
                settled_end_at: payload.settled_end_at ? getUnixTime(+payload.settled_end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_COMMISSION_FINANCE_FEE_DETAIL, { data });
        },
        getCommissionDetailFinanceFeeDetails(payload) {
            const data = {
                ...payload,
                settled_start_at: payload.settled_start_at ? getUnixTime(+payload.settled_start_at) : undefined,
                settled_end_at: payload.settled_end_at ? getUnixTime(+payload.settled_end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_COMMISSION_FINANCE_FEE_DETAIL_DETAILS, { data });
        },
        // bet,
        getBetAgent(payload) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_BET_AGENT, { data });
        },
        getBetAgentExport(payload) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_BET_AGENT_EXPORT, { data });
        },
        getBetPlayer(payload) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_BET_PLAYER, { data });
        },
        getBetDetail(payload) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_BET_PLAYER_DETAIL, { data }).pipe(map((res) => ({ ...res, data: res.data.map((item) => convertUnixToDate(item, 'original_created_at', 'settled_at')) })));
        },
        // leaderboard
        getLeaderboard(payload) {
            const data = {
                ...payload,
                settled_start_at: payload.settled_start_at ? getUnixTime(+payload.settled_start_at) : undefined,
                settled_end_at: payload.settled_end_at ? getUnixTime(+payload.settled_end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_LEADERBOARD, { data });
        },
        // activity
        getActivityAgent(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_AGENT, { data, config: { urlParams: { id } } });
        },
        getActivityPlayer(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER, { data, config: { urlParams: { id } } });
        },
        getActivityPlayerDetail(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_DETAIL, { data, config: { urlParams: { id } } });
        },
        getActivityPlayerNewMemberBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_NEW_MEMBER_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'updated_at'))
            })));
        },
        getActivityPlayerRecommendFriend(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_RECOMMEND_FRIEND, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'updated_at'))
            })));
        },
        getActivityPlayerInviteFriend(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_INVITE_FRIEND, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        getActivityPlayerUpgradeBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_UPGRADE_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'received_at', 'updated_at'))
            })));
        },
        getActivityPlayerDailySignIn(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_DAILY_SIGN_IN, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'updated_at'))
            })));
        },
        getActivityPlayerWeeklyBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_WEEKLY_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'received_at', 'updated_at'))
            })));
        },
        getActivityPlayerBirthdayBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_BIRTHDAY_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'received_at', 'updated_at'))
            })));
        },
        getActivityPlayerManualEvent(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_MANUAL_EVENT, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'operated_at'))
            })));
        },
        getActivityPlayerNewYear2023(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_NEW_YEAR_2023, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'updated_at'))
            })));
        },
        getActivityPlayerNewYear2024(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_NEW_YEAR_2024, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'received_at'))
            })));
        },
        getActivityPlayerNewYear2025Draw(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_NEW_YEAR_2025_DRAW, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityPlayerNewYear2025RedEnvelope(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_NEW_YEAR_2025_RED_ENVELOPE, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityPlayerNewYear2026Ticket(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_NEW_YEAR_2026_TICKET, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityPlayerNewYear2026RedEnvelope(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_NEW_YEAR_2026_RED_ENVELOPE, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityPlayerDepositBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_DEPOSIT_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        getActivityPlayerUefaBuildingUp(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_UEFA_BUILDING_UP, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'received_at'))
            })));
        },
        getActivityPlayerUefaStars(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_UEFA_STARS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityPlayerWeeklyBonusDraw(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_WEEKLY_BONUS_DRAW, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityPlayerDailyBonusDraw(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_DAILY_BONUS_DRAW, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityPlayerManualActivityWallet(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_MANUAL_ACTIVITY_WALLET, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        getActivityPlayerGashStore(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(+payload.start_at),
                end_at: getUnixTime(+payload.end_at)
            };
            return api.fetch(AGENT_API.GET_ACTIVITY_PLAYER_GASH_STORE, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        // transaction
        getTransactionSummary(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_TRANSACTION_SUMMARY, { data, config: { urlParams: { id } } });
        },
        getTransactionAgent(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_TRANSACTION_AGENT, { data, config: { urlParams: { id } } });
        },
        getTransactionPlayer(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_TRANSACTION_PLAYER, { data, config: { urlParams: { id } } });
        },
        getTransactionPlayerSummary(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_TRANSACTION_PLAYER_SUMMARY, { data, config: { urlParams: { id } } });
        },
        getTransactionDepositHistory(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_TRANSACTION_PLAYER_DEPOSIT_HISTORY, { data, config: { urlParams: { id } } }).pipe(map((res) => ({ ...res, data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'finished_at')) })));
        },
        getTransactionWithdrawHistory(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_TRANSACTION_PLAYER_WITHDRAW_HISTORY, { data, config: { urlParams: { id } } }).pipe(map((res) => ({ ...res, data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'finished_at')) })));
        },
        getTransactionAgentsExport(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_TRANSACTION_AGENT_EXPORT, { data, config: { urlParams: { id } } });
        },
        getTransactionPlayersExport(payload, id) {
            const data = {
                ...payload,
                start_at: payload.start_at ? getUnixTime(+payload.start_at) : undefined,
                end_at: payload.end_at ? getUnixTime(+payload.end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_TRANSACTION_PLAYER_EXPORT, { data, config: { urlParams: { id } } });
        }
    };
}
//# sourceMappingURL=ReportService.js.map